import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index.js'

/* Authentication */
import Auth from '../auth/auth';
import Login from '../auth/login';
import Register from '../auth/register';
import Forgot from '../auth/forgot';
import PageSingle from '../pages/PageSingle'
import GeneratePlan from '../pages/GeneratePlan.vue'

import Body from '../components/body'
import BodyNoSidebar from '../components/body_no_sidebar'
import BodyPrint from '../components/body_print.vue'

import UserProfile from "../pages/Projects/UserProfile";
import DictionaryList from "../pages/Projects/DictionaryList";
import PdfProjectExport from "../pages/Projects/PdfProjectExport"

/* Projects */


import ProjectsList from '../pages/Projects/ProjectsList'
import ProjectEdit from '../pages/Projects/ProjectEdit'
import ProjectPlan from '../pages/Projects/ProjectPlan'
import ProjectTeam from "@/pages/Projects/ProjectTeam";
import ProjectChat from '@/pages/Projects/ProjectChat'
import ProjectBudget from '@/pages/Budget/BudgetWrapper'
import SingleProjectBudget from '@/pages/Budget/SingleProjectBudget'
import ProjectCompetences from "@/pages/Projects/ProjectCompetences";
import ProjectExport from "@/pages/Projects/ProjectExport";

Vue.use(Router);


const routes = [

    {
        name: 'Main',
        path: '/',
        component: BodyNoSidebar,
        redirect: {name: 'Login'},
        // children: [
        // 	{
        // 		path: 'home',
        // 		name: 'Home',
        // 		component: Home,
        // 		meta: {
        // 			title: ' Login | Game of business',
        // 		}
        // 	}
        // ]
    },
    {
        name: 'Pages',
        path: '/page',
        component: BodyNoSidebar,
        children: [
            {
                path: ':slug',
                name: 'SinglePage',
                component: PageSingle,
                meta: {
                    title: ' Login | Game of business',
                }
            }
        ]
    },
    // {
    // 	name: 'Blog',
    // 	path: '/blog',
    // 	component: BodyNoSidebar,
    // 	redirect: {name: 'Blog'},
    // 	children: [
    // 		{
    // 			path: 'list',
    // 			name: 'Blog',
    // 			component: Blog,
    // 			meta: {
    // 				title: ' Blog | Game of business',
    // 			}
    // 		},
    // 		{
    // 			path: 'single',
    // 			name: 'BlogSingle',
    // 			component: BlogSingle,
    // 			meta: {
    // 				title: ' Blog | Game of business',
    // 			}
    // 		}
    // 	]
    // },
    {
        name: 'UserWrap',
        path: '/user',
        component: BodyNoSidebar,
        children: [
            {
                name: 'UserProfile',
                path: 'profile',
                component: UserProfile,
                meta: {
                    title: ' User profile | Projects list',
                }
            }]
    },
    {
        name: 'pdfExport',
        path: '/plan/',
        component: BodyNoSidebar,
        children: [
            {
                name: 'pdfExportPage',
                path: 'pdf/:id/:token',
                component: PdfProjectExport,
                meta: {
                    title: ' PDF export',
                }
            }]
    },
    {
        name: 'Dictionary',
        path: '/dictionary',
        component: BodyNoSidebar,
        children: [
            {
                name: 'DictionaryInfo',
                path: 'list',
                component: DictionaryList,
                meta: {
                    title: ' Dictionary | Projects list',
                }
            }]
    },
    {
        name: 'Auth',
        path: '/auth',
        component: Auth,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: Login,
                meta: {
                    title: ' Login | Game of business',
                }
            },
            {
                path: 'register',
                name: 'Register',
                component: Register,
                meta: {
                    title: ' Register | Game of business',
                }
            },
            {
                path: 'forgot-password',
                name: 'Forgot',
                component: Forgot,
                meta: {
                    title: ' Forgot password | Game of business',
                }
            }
        ]
    },
    {
        name: 'Projects',
        path: '/projects',
        component: Body,
        redirect: {name: 'ProjectsList'},
        children: [
            {
                name: 'ProjectsList',
                path: 'list',
                component: ProjectsList,
                meta: {
                    title: ' Projects | Projects list',
                }
            },
            {
                name: 'ProjectEdit',
                path: 'fill/:id',
                component: ProjectEdit,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },
            {
                name: 'ProjectPlan',
                path: 'plan/:id/:module',
                component: ProjectPlan,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },
            {
                name: 'ProjectBudget',
                path: 'budget/:id',
                component: ProjectBudget,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },
            {
                name: 'ProjectCompetences',
                path: 'competences/:id',
                component: ProjectCompetences,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },

            {
                name: 'SingleProjectBudget',
                path: 'budget/:id/:budgetId',
                component: SingleProjectBudget,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },
            {
                name: 'ProjectExport',
                path: 'export/:id',
                component: ProjectExport,
                meta: {
                    title: ' Edit project | Game of business',
                }
            },
            {
                name: 'ProjectTeam',
                path: 'team/:id',
                component: ProjectTeam,
                meta: {
                    title: ' Project team | Game of business',
                }
            },
            {
                name: 'ProjectChat',
                path: 'chat/:id',
                component: ProjectChat,
                meta: {
                    title: ' Project chat | Game of business',
                }
            }
        ]
    },
    {
        name: 'Public',
        path: '/public',
        component: BodyPrint,
        children: [
            {
                name: 'PublicPlan',
                path: 'plan/:id',
                component: GeneratePlan,
                meta: {
                    title: ' Public plan | Share',
                }
            },
        ]
    },
    {path: "*", redirect: {name: 'Login'}}
];

const router = new Router({
    routes,
    // base: process.env.BASE_URL,
    mode: 'history',
    linkActiveClass: 'active',
    scrollBehavior() {
        return {x: 0, y: 0};
    }
});

router.beforeEach((to, from, next) => {

    if (to.meta.title) {
        document.title = to.meta.title;
    }

    if (to.name != 'Login' && to.name != 'Register' && to.name != 'Forgot' && to.name != 'PublicPlan') {

        if (!store.getters['shared/isAuthenticated']) {

            if (sessionStorage.getItem('access_token')) {

                store.dispatch('shared/tryAutoLogin').then(() => {

                    let user = store.getters['shared/getUser']


                    if (user.name != '') {

                        if (to.name != 'ProjectsList') {

                            if (user.share && user.share.length) {

                                let hasAccess = user.share.find((item) => {
                                    return item.project_id == to.params.id
                                })

                                if (hasAccess || to.name == 'UserProfile') {
                                    next()
                                } else {

                                    next({
                                        name: 'ProjectsList',
                                        replace: true
                                    })

                                }
                            } else {

                                next({
                                    name: 'ProjectsList',
                                    replace: true
                                })

                            }

                        } else {
                            next()
                        }
                    } else {
                        next({
                            name: 'UserProfile',
                            replace: true
                        })
                    }
                })
            } else {

                next({
                    name: 'Login',
                    replace: true
                })
            }

        } else {

            if (to.name != 'ProjectsList' && to.name != 'UserProfile') {

                let user = store.getters['shared/getUser']

                if (user.share && user.share.length) {

                    let hasAccess = user.share.find((item) => {
                        return item.project_id == to.params.id
                    })

                    if (hasAccess) {
                        next()
                    } else {

                        next({
                            name: 'ProjectsList',
                            replace: true
                        })

                    }
                } else {

                    next({
                        name: 'ProjectsList',
                        replace: true
                    })
                }

            } else {

                let user = store.getters['shared/getUser']

                if (to.name != 'UserProfile' && user.name == '') {

                    next({
                        name: 'UserProfile',
                        replace: true
                    })

                } else {
                    next()
                }
            }
        }

    } else {
        next();
    }

});

export default router;
